import axiosInstance from './AxiosInstance';

export function getBusinessCategories(role) {
    return axiosInstance.get(`user/business-categories?role=${role}`);
}